<div class="section-title">
  <span class="title-text">{{ title }}</span>
  <button
    qai-link
    *ngIf="showDetails"
    [disabled]="actiondisabled"
    (click)="onActionClick($event)"
    class="title-action"
  >
    {{ detailsText }}
  </button>
</div>
<div class="section-description" *ngIf="!!description">{{ description }}</div>
<div class="section-content">
  <ng-content></ng-content>
</div>
